<template>
    <div class="news_item" >
        <div class="l">
            <b>{{ new Date(data.createTime).getDay() }}</b>
            <p>{{ new Date(data.createTime).getFullYear() + '-' + (new Date(data.createTime).getMonth() + 1)  }}</p>
            <img src="@/assets/imgs/icon73.png" alt="">
        </div>
        <div class="r">
            <span>通知公告</span>
            <h4>{{ data.title }}</h4>
            <p>{{ data.synopsis }}</p>
        </div>
    </div>
</template>
<script setup>
import { richTextToPlainText } from '@/utils/util.js'
import { useRouter } from 'vue-router';
const router = useRouter()
defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
})
</script>

<style scoped lang="scss">
.news_item {
    width: 100%; padding: 30rem 15rem; background-color: #F5F5F5; border: 1px solid #E7E7E7; display: flex; justify-content: space-between;
    .l{
        width: 15%; display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img{
            width: 80%;
        }
        p{
            margin: 10rem 0; color: #666666;
        }
        b{
            font-size: 26rem; color: #726FF9;
        }
    }
    .r{
        width: 75%;
        h4{
            white-space: nowrap; 
            overflow: hidden;
            text-overflow: ellipsis; margin: 10rem 0; color: #333;
        }
        span{
            display: inline-block;
            font-size: 10rem;
            color: #fff;
            height: 17rem;
            line-height: 17rem;
            background-color: #AAA9FB;
            text-align: center;
            border-radius: 3rem;
            padding: 0 5rem;
        }
        p{
            font-size: 14rem; color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
}
</style>